import filters from "./tracking/filters";
import metric from "./tracking/metric";
import report from "./tracking/report";

const createBenchmarkTrackerTrackingService = () => {
    return {
        metric,
        filters,
        report,
    };
};

export const benchmarkTrackerTracking = createBenchmarkTrackerTrackingService();
